// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/Georama_SemiCondensed-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Georama:wght@400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Georama SemiCondensed";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 400;
}

body {
  margin: auto;
  line-height: normal;
  font-family: var(--font-lato);
  font-size: 1rem;
  height: 100%;
  color: var(--secondary-color);
}

:root {
  /* fonts */
  --title: "Georama SemiCondensed";
  --font-lato: Lato;
  --navbar1: Georama;

  /* font sizes */
  --title-1-desktop-size: 3rem;
  --title-1-tablet-size: 2.5rem;
  --title-2-desktop-size: 2.2rem;
  --title-2-tablet-size: 1.6rem;
  --title-3-desktop-size: 1.75rem;
  --title-3-tablet-size: 1.375rem;
  --title-4-desktop-size: 1.5rem;
  --title-4-tablet-size: 1.19rem;
  --title-5-desktop-size: 1.25rem;
  --title-5-tablet-size: 1rem;

  /* Colors */
  --primary-color: #e40032;
  --secondary-color: #333f4c;
  --gray: #d9d9d9;
  --lightGray: #f7f6f7;
  --white: #fff;
  --info-color: #1581bf;
  --success-color: #8bc74e;
  --warning-color: #ecaa07;
  --pending-color: #e5e912;

  /* Gaps */
  --gap-md: 0.31rem;
  --gap-lg: 1rem;

  /* Paddings */
  --padding-sm: 1.38rem;
  --padding-md: 3rem;
}

.section {
  margin: auto;
  margin-top: 3rem;
}

.displayFlexCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spaceBetweenContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.spaceBetweenContainerStart {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.flexWrap {
  display: flex;
  flex-wrap: wrap;
}

.flexWrapStart {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.flexWrapSpaceBetween {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.flexColumnContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.flexColumnContainerAlignStart {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
}

.userCard {
  width: 70%;
  margin: 0 auto;
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
}

.formContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.mediumContainer {
  width: 48%;
}

.largeContainer {
  width: 90%;
}

.badgeContainer {
  width: 11rem;
}

.select {
  margin-bottom: 1rem;
}

textarea,
p {
  text-align: justify;
}

.link {
  margin-top: 2rem;
}

.actionIcon {
  margin-right: 0.5rem;
  cursor: pointer;
  color: var(--secondary-color);
}

.actionIcon:hover {
  color: var(--primary-color);
}

.button {
  width: 8.75rem;
  cursor: pointer;
  margin: 2rem 2rem 1rem 0;
}

.fit {
  width: -moz-fit-content;
  width: fit-content;
}

.largeButton {
  width: 90%;
  margin-top: 2rem;
}

.message {
  display: none;
  color: var(--primary-color);
}

li:hover {
  background-color: var(--gray);
  cursor: pointer;
}

.footerContainer {
  bottom: 0;
  position: absolute;
  width: 100%;
}

.headerEditor {
  background-color: white !important;
}

.buttonIconDisabled {
  cursor: not-allowed;
  opacity: 0.3;
  margin-right: 0.5rem;
}

.toggleButton {
  width: 100%;
}

/* Overload the css of the library loader */
.spinnerPlayLoading {
  width: 2rem !important;
  height: 2rem !important;
  border-width: 0.25em !important;
  margin-right: 0.5rem;
}

.spinnerPlayLoadingOutput {
  width: 2rem !important;
  height: 2rem !important;
  border-width: 0.25em !important;
}

.iconToast {
  margin-right: 0.5rem;
  color: var(--warning-color);
}

.buttonHeaderCard {
  align-items: center;
  display: flex;
  gap: 0.8rem;
}

.textTruncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.testAccordionSection {
  margin-bottom: 3rem;
}

.accordionCard {
  margin: 1rem;
  height: 75vh;
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAGA;EACE,oCAAoC;EACpC,4CAAuD;EACvD,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;;EAElB,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;;EAE3B,WAAW;EACX,wBAAwB;EACxB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,SAAS;EACT,iBAAiB;EACjB,cAAc;;EAEd,aAAa;EACb,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Georama:wght@400&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap\");\r\n\r\n@font-face {\r\n  font-family: \"Georama SemiCondensed\";\r\n  src: url(\"../public/Georama_SemiCondensed-Regular.ttf\");\r\n  font-weight: 400;\r\n}\r\n\r\nbody {\r\n  margin: auto;\r\n  line-height: normal;\r\n  font-family: var(--font-lato);\r\n  font-size: 1rem;\r\n  height: 100%;\r\n  color: var(--secondary-color);\r\n}\r\n\r\n:root {\r\n  /* fonts */\r\n  --title: \"Georama SemiCondensed\";\r\n  --font-lato: Lato;\r\n  --navbar1: Georama;\r\n\r\n  /* font sizes */\r\n  --title-1-desktop-size: 3rem;\r\n  --title-1-tablet-size: 2.5rem;\r\n  --title-2-desktop-size: 2.2rem;\r\n  --title-2-tablet-size: 1.6rem;\r\n  --title-3-desktop-size: 1.75rem;\r\n  --title-3-tablet-size: 1.375rem;\r\n  --title-4-desktop-size: 1.5rem;\r\n  --title-4-tablet-size: 1.19rem;\r\n  --title-5-desktop-size: 1.25rem;\r\n  --title-5-tablet-size: 1rem;\r\n\r\n  /* Colors */\r\n  --primary-color: #e40032;\r\n  --secondary-color: #333f4c;\r\n  --gray: #d9d9d9;\r\n  --lightGray: #f7f6f7;\r\n  --white: #fff;\r\n  --info-color: #1581bf;\r\n  --success-color: #8bc74e;\r\n  --warning-color: #ecaa07;\r\n  --pending-color: #e5e912;\r\n\r\n  /* Gaps */\r\n  --gap-md: 0.31rem;\r\n  --gap-lg: 1rem;\r\n\r\n  /* Paddings */\r\n  --padding-sm: 1.38rem;\r\n  --padding-md: 3rem;\r\n}\r\n\r\n.section {\r\n  margin: auto;\r\n  margin-top: 3rem;\r\n}\r\n\r\n.displayFlexCenter {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.spaceBetweenContainer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.spaceBetweenContainerStart {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n}\r\n\r\n.flexWrap {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.flexWrapStart {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-start;\r\n}\r\n\r\n.flexWrapSpaceBetween {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n}\r\n\r\n.flexColumnContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.flexColumnContainerAlignStart {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n}\r\n\r\n.userCard {\r\n  width: 70%;\r\n  margin: 0 auto;\r\n  padding: 2rem;\r\n  border-radius: 0.5rem;\r\n  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.formContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 1.5rem;\r\n}\r\n\r\n.mediumContainer {\r\n  width: 48%;\r\n}\r\n\r\n.largeContainer {\r\n  width: 90%;\r\n}\r\n\r\n.badgeContainer {\r\n  width: 11rem;\r\n}\r\n\r\n.select {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\ntextarea,\r\np {\r\n  text-align: justify;\r\n}\r\n\r\n.link {\r\n  margin-top: 2rem;\r\n}\r\n\r\n.actionIcon {\r\n  margin-right: 0.5rem;\r\n  cursor: pointer;\r\n  color: var(--secondary-color);\r\n}\r\n\r\n.actionIcon:hover {\r\n  color: var(--primary-color);\r\n}\r\n\r\n.button {\r\n  width: 8.75rem;\r\n  cursor: pointer;\r\n  margin: 2rem 2rem 1rem 0;\r\n}\r\n\r\n.fit {\r\n  width: fit-content;\r\n}\r\n\r\n.largeButton {\r\n  width: 90%;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.message {\r\n  display: none;\r\n  color: var(--primary-color);\r\n}\r\n\r\nli:hover {\r\n  background-color: var(--gray);\r\n  cursor: pointer;\r\n}\r\n\r\n.footerContainer {\r\n  bottom: 0;\r\n  position: absolute;\r\n  width: 100%;\r\n}\r\n\r\n.headerEditor {\r\n  background-color: white !important;\r\n}\r\n\r\n.buttonIconDisabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.3;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.toggleButton {\r\n  width: 100%;\r\n}\r\n\r\n/* Overload the css of the library loader */\r\n.spinnerPlayLoading {\r\n  width: 2rem !important;\r\n  height: 2rem !important;\r\n  border-width: 0.25em !important;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.spinnerPlayLoadingOutput {\r\n  width: 2rem !important;\r\n  height: 2rem !important;\r\n  border-width: 0.25em !important;\r\n}\r\n\r\n.iconToast {\r\n  margin-right: 0.5rem;\r\n  color: var(--warning-color);\r\n}\r\n\r\n.buttonHeaderCard {\r\n  align-items: center;\r\n  display: flex;\r\n  gap: 0.8rem;\r\n}\r\n\r\n.textTruncate {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.testAccordionSection {\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.accordionCard {\r\n  margin: 1rem;\r\n  height: 75vh;\r\n  overflow: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
